
import React, { useState } from "react";
import { cn } from "@/lib/utils";

function getWebPSrc(_src: string | undefined): string | undefined {
  // Disabled: no .webp variants exist for uploaded images
  return undefined;
}

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  className?: string;
}

const Image = React.forwardRef<HTMLImageElement, ImageProps>(({
  className,
  alt,
  src,
  loading = "lazy",
  ...props
}, ref) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const webpSrc = getWebPSrc(src);
  const hasWebPVariant = webpSrc && webpSrc !== src;

  const titleText = props.title || alt || undefined;

  const imgElement = (
    <img 
      ref={ref} 
      alt={alt || "Image"} 
      title={titleText}
      src={src}
      className={cn(
        "max-w-full h-auto rounded-md transition-opacity duration-300",
        isLoaded ? "opacity-100" : "opacity-0",
        className
      )} 
      loading={loading}
      decoding="async"
      onLoad={() => setIsLoaded(true)}
      width={props.width || 800}
      height={props.height || 600}
      {...props} 
    />
  );

  if (hasWebPVariant) {
    return (
      <picture>
        <source srcSet={webpSrc} type="image/webp" />
        {imgElement}
      </picture>
    );
  }

  return imgElement;
});

Image.displayName = "Image";

export { Image };
